import React from "react";
import { KpiCard, Panel, StatRow } from "@/pages/dashboard/widgets";

export default function DispatchView({ data }) {
  if (!data) return null;
  return (
    <div className="space-y-6" data-testid="dispatch-view">
      <div className="grid grid-cols-2 gap-4 lg:grid-cols-4">
        <KpiCard testid="dsp-kpi-ready" label="Orders ready" value={data.orders_ready ?? 0} accent="text-amber-600" />
        <KpiCard testid="dsp-kpi-picking" label="Picking in progress" value={data.picking_in_progress ?? 0} accent="text-indigo-600" />
        <KpiCard testid="dsp-kpi-today" label="Today's dispatches" value={data.todays_dispatches ?? 0} accent="text-emerald-600" />
        <KpiCard testid="dsp-kpi-pending" label="Pending deliveries" value={data.pending_deliveries ?? 0} accent="text-sky-600" />
      </div>
      <Panel title="Fulfilment">
        <StatRow items={[
          { label: "Partial shipments", value: data.partial_shipments ?? 0, accent: "text-amber-600" },
          { label: "In transit", value: data.pending_deliveries ?? 0 },
          { label: "Ready to ship", value: data.orders_ready ?? 0 },
        ]} />
      </Panel>
    </div>
  );
}
